// extracted by mini-css-extract-plugin
module.exports = {"ColoredBox":"ColoredBox_ColoredBox__yUsbX"};